//#region src/shared/nullish.ts
function isNullish(value) {
	return value === null || value === void 0;
}

//#endregion
export { isNullish };
//# sourceMappingURL=nullish.js.map